import React from "react";

/**
 * Render the `**bold**` spans that appear inside portfolio strings.
 *
 * The CV JSON uses inline markdown for emphasis only — no links, lists or
 * headings — so react-markdown (which wraps its output in block elements and
 * fights the surrounding layout) is the wrong tool here. It stays where it
 * belongs, rendering full article bodies in LessonDetailPage.
 */
export function renderInlineBold(text) {
  return String(text)
    .split(/(\*\*[^*]+\*\*)/g)
    .map((part, i) =>
      part.startsWith("**") && part.endsWith("**") ? (
        <strong key={i} className="font-semibold text-slate-900">
          {part.slice(2, -2)}
        </strong>
      ) : (
        <span key={i}>{part}</span>
      )
    );
}

export default renderInlineBold;
